import color from "../../constants/color";

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    p: 3,
  },
  card: {
    backgroundColor: color.card,
    borderRadius: "16px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    maxWidth: "520px",
    width: "100%",
    p: { xs: 3, md: 5 },
    textAlign: "center",
  },
  icon: {
    fontSize: "48px",
    color: color.primary,
    mb: 1,
  },
  heading: {
    fontSize: "20px",
    fontWeight: "600",
    color: color.text,
    mb: 1,
  },
  message: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "22px",
    color: color.lightText,
    mb: 3,
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 2,
  },
  primaryButton: {
    textTransform: "none",
    fontWeight: "600",
    backgroundColor: color.primary,
    "&:hover": { backgroundColor: "#1f8a3a" },
  },
  secondaryButton: {
    textTransform: "none",
    fontWeight: "600",
    borderColor: color.primary,
    color: color.primary,
    "&:hover": { borderColor: "#1f8a3a", backgroundColor: color.lightGreen },
  },
};

export default styles;
